export default __webpack_public_path__ + "static/media/tim-safari-icon.97783d3d.png";